<div class="feedback-content {{ !isSmallIcon ? 'feedback-content-bt' : 'feedback-content-tp' }}" *ngIf="isShowTutorial" title="Video Tutorial Guide">
  <!-- Show loader while fetching tutorials -->
  <div *ngIf="isLoading" class="spinner-grow text-success" role="status">
    <span class="sr-only">Loading...</span>
  </div>

  <img
    class="img-feeback cursor-pointer {{ !isSmallIcon ? 'img-sm-feedback' : 'img-bg-feedback' }}"
    [src]="!isSmallIcon ? '/assets/images/video-tutorial-btn-sm.svg' : '/assets/images/video-tutorial-btn.svg'"
    *ngIf="!showIcons && !isLoading"
    alt="video-tutorial"
    (click)="openVideoTutorial()"
  />

  <div *ngIf="showIcons && videoTutorials?.length > 1" class="overlay">
    <div class="icon-main-content">
      <div *ngFor="let tutorial of videoTutorials; let i = index" class="video-item icons-container">
        <p class="quicksand-bold-label description m-0 text-center" (click)="openVideo(tutorial.url)">
          {{ tutorial.description }}
        </p>
        <div class="icon-content" [ngClass]="{ 'extra-padd-content': i === 0 || i === 1 }">
          <img
            [src]="i === 0 ? '/assets/icons/copy-tutorial.svg' : i === 1 ? '/assets/icons/edit-tutorial.svg' : '/assets/icons/rocket.svg'"
            alt="Video Tutorial"
            class="{{ i === 0 || i === 1 ? 'icon-first' : 'icon' }} cursor-pointer"
            (click)="openVideo(tutorial.url)"
          />
        </div>
      </div>

      <img *ngIf="videoTutorials?.length > 1" src="/assets/icons/Close-icon.svg" alt="Close Tutorials" class="close-icon" (click)="showIcons = false" />
    </div>
  </div>

  <ng-template #videoTutorialDialog>
    <div class="feedback-dialog">
      <span class="icon-close-classroom-modal d-block cursor-pointer p-2 m-3 ml-auto" (click)="matDialogService.closeAll()">
        <nb-icon icon="close-outline" class="icon-close"></nb-icon>
      </span>
      <div class="feedback-dialog-content quicksand-bold-label" *ngIf="tutorialData">
        {{ tutorialData?.description }}

        <div class="form-group mt-4">
          <video
            [src]="tutorialData?.video?.url"
            class="w-100"
            alt="feeback-media"
            preload="metadata"
            webkit-playsinline="webkit-playsinline"
            playsinline
            controls
            autoplay
            style="height: auto"
          ></video>
        </div>
      </div>

      <div class="feedback-dialog-content quicksand-bold-label text-center" *ngIf="!tutorialData">
        We are constantly working on tutorials that guide you to get more knowledge about software processes!

        <div class="text-center">
          <img src="/assets/images/respond-edu.svg" height="200" width="200" alt="no-data-found" />
        </div>
      </div>
    </div>
  </ng-template>
</div>
